import {EnvironmentModel} from "./model/environment.model";

export const environment = new EnvironmentModel();
